import { useSyncExternalStore } from 'react';
import envConfig from '../../config/environment';

export enum PermissionTestMode {
    NORMAL = 'NORMAL',
    ALLOW_ALL = 'ALLOW_ALL',
    DENY_ALL = 'DENY_ALL'
};

let mode: PermissionTestMode = PermissionTestMode.NORMAL;
let listeners: Set<() => void> = new Set();

export const setPermissionTestMode = (newMode: PermissionTestMode) => {
    mode = newMode;
    listeners.forEach((listener) => listener());
};



export const getPermissionTestMode = () => mode;


declare global {
    interface Window {
        __set_permission_test_mode__?: (mode: PermissionTestMode) => void;
        __get_permission_test_mode__?: () => PermissionTestMode;
    }
}
if (envConfig.ENVIRONMENT !== 'production') {
    window.__set_permission_test_mode__ = setPermissionTestMode;
    window.__get_permission_test_mode__ = getPermissionTestMode;
}

export const subscribePermissionMode = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const usePermissionTestMode = (): PermissionTestMode => {
    return useSyncExternalStore(subscribePermissionMode, getPermissionTestMode);
};

